import * as React from "react";
import { Field, FormikTouched } from "formik";
import MaskedInput from "react-text-mask";

interface IMaskedFormFieldProps {
	name: string;
	placeholder: string;
	setFieldValue: any;
	setTouched: (touched: FormikTouched<unknown>) => void;
	errors: any;
	touched: any;
	mask: any;
	values: any;
	colorTheme: string;
	isColumn: boolean;
}
export default function MaskedFormField(props: IMaskedFormFieldProps) {
	return (
		<div className={props.isColumn ? "col-md-12 my-1 px-4" : "col-md-6 my-2"}>
			<Field
				name={props.name}
				render={(field: any) => {
					return (
						<MaskedInput
							{...field}
							value={props.values[props.name]}
							onChange={(e) => props.setFieldValue(props.name, e.target.value)}
							className={`form-control no-border ${
								props.errors[props.name] && props.touched[props.name]
									? "error-validation-" + props.colorTheme
									: null
							}`}
							mask={props.mask}
							guide={true}
							placeholder={props.placeholder}
							onFocus={() => {
								const newTouched = { ...props.touched };
                                newTouched[props.name] = true;
								props.setTouched(newTouched);
							}}
						/>
					);
				}}
			/>
		</div>
	);
}
